import { useState, useRef, useEffect } from "react";

const LAT = 59.930232;
const LON = 30.354353;

const MAP_OPTIONS = [
  {
    label: "Яндекс Навигатор",
    sub: "Построить маршрут",
    url: `https://yandex.ru/maps/?rtext=~${LAT},${LON}&rtt=auto`,
  },
  {
    label: "Яндекс Карты",
    sub: "Показать на карте",
    url: `https://yandex.ru/maps/?ll=${LON},${LAT}&z=17&pt=${LON},${LAT},pm2rdl`,
  },
  {
    label: "Google Карты",
    sub: "Показать на карте",
    url: `https://www.google.com/maps/search/?api=1&query=${LAT},${LON}`,
  },
];

interface MapPickerProps {
  label?: string;
  className?: string;
  dropUp?: boolean;
  align?: "left" | "right";
}

export default function MapPicker({
  label = "Ул. Марата, 5",
  className = "",
  dropUp = true,
  align = "left",
}: MapPickerProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const menuPos = dropUp
    ? "bottom-full mb-2"
    : "top-full mt-2";

  const menuAlign = align === "right" ? "right-0" : "left-0";

  return (
    <div ref={ref} className={`relative inline-block ${className}`}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="true"
        className="text-left hover:opacity-70 transition-opacity focus:outline-none group"
      >
        <span className="border-b border-current border-dashed border-opacity-40 group-hover:border-opacity-80 transition-all">
          {label}
        </span>
      </button>

      {open && (
        <div
          className={`absolute z-[250] ${menuPos} ${menuAlign} bg-[#0a1a0e] border border-primary/30 shadow-2xl min-w-[210px] overflow-hidden`}
        >
          <div className="px-4 py-2.5 border-b border-primary/10">
            <p className="text-[9px] tracking-[0.25em] text-primary/50 uppercase">Открыть в</p>
          </div>
          {MAP_OPTIONS.map((opt) => (
            <a
              key={opt.label}
              href={opt.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between gap-4 px-4 py-3 hover:bg-primary/10 transition-colors border-b border-primary/10 last:border-0 group/item"
              onClick={() => setOpen(false)}
            >
              <div>
                <p className="text-sm text-foreground font-medium leading-tight group-hover/item:text-primary transition-colors">
                  {opt.label}
                </p>
                <p className="text-[10px] text-muted-foreground mt-0.5">{opt.sub}</p>
              </div>
              <svg className="w-3.5 h-3.5 text-primary/40 group-hover/item:text-primary transition-colors shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
